export default __webpack_public_path__ + "static/media/BAPE.f1fa7bee.svg";